import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import actions from 'redux-auto'

export function useAbteilungen() {
  const canView = useSelector(state => state.authentication.permissions.abteilungen.view)
  const abteilungen = useSelector(state => state.meineAusbilder.abteilungen, shallowEqual)
  const isLoadingSelector = state => state.meineAusbilder.loading.getAllAbteilungen !== false
  const isLoading = useSelector(isLoadingSelector)

  useEffect(() => {
    if (canView) {
      actions.meineAusbilder.getAllAbteilungen()
    }
  }, [])

  return {abteilungen, isLoading}
}
